import React from 'react';
import { Link } from 'react-router-dom';
import { prepareUrl } from 'services/DataSource';
import Show from 'services/Show';
import Contest from 'services/Contest';
import { Spinner } from 'components/atoms';
import { handleErrors, formatDate } from 'services/utils'


export default class ShowSummary extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      sendingTickets: false,
      contestLoading: false,
      show: null,
      showId: match.params.id,
    }
    this.mounted = false;
    this.contestExpertsSet = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  itemChanged = (item) => {
    this.setState({ item });
  }

  loadData = () => {
    this.setState({loading: true, contestLoading: true});
    Show.get(this.state.showId, {with_experts: true}).then((show) => {
      if (this.mounted) {
        this.setState({ show, loading: false });
      }
    }).catch((request) => {
      if (this.mounted) {
        handleErrors(request);
        this.setState({ loading: false });
      }
    });
    Contest.query({show_id: this.state.showId}).then(({items, paging}) => {
      if (this.mounted) {
        this.setState( { contests: items, contestLoading: false } );
      }
    }).catch((request) => {
      if (this.mounted) {
        handleErrors(request);
        this.setState( { contestLoading: false } );
      }
    });
  }

  sendTickets = () => {
    this.setState({ sendingTickets: true });
    this.state.show.sendTickets().then(() => {
      if (this.mounted) {
        alert('Задание на оправку талонов запущено.');
        this.setState({ sendingTickets: false });
      }
    }).catch((request) => {
      if (this.mounted) {
        handleErrors(request);
        this.setState({ sendingTickets: false });
      }
    });
  }

  resetTicketSent = () => {
    this.setState({ sendingTickets: true });
    this.state.show.resetTicketSent().then(() => {
      if (this.mounted) {
        alert('Флаги талонов сняты.');
        this.setState({ sendingTickets: false });
        this.loadData();
      }
    }).catch((request) => {
      if (this.mounted) {
        handleErrors(request);
        this.setState({ sendingTickets: false });
      }
    });
  }

  
  showMainInfo(show) {
    if (!show) return null;
    return (
      <span className="show">
        <strong className="show-name"> {show.name} </strong>
        <i> / </i>
        <span className="show-date"> {formatDate(show.starts_at)} </span>
      </span>
    );
  }

  renderShowInfo(show) {
    if (!show) return null;
    return <div>
      <p>
        Зарегистрировано <Link to={`/shows/${show.id}/dogs`}>{show.dogs_count} собак</Link>.<br />
        Отправлено {show.tickets_sent || 0} из {show.dogs_may_get_ticket || 0} талонов участников.
        <button onClick={this.sendTickets} disabled={this.state.sendingTickets} className="btn btn-link">Отправить талоны участникам</button>
        <button onClick={this.resetTicketSent} disabled={this.state.sendingTickets} className="btn btn-link">Снять флаги отправленных талонов</button>
        <br />
        <Link to={`/shows/${show.id}/catalog-recipients`}>{show.dogs_amount_need_catalog} участникам </Link> нужен каталог.
      </p>
      <p>
        <Link to={`/shows/${show.id}/certificates`}>Сертификаты</Link>
        , &nbsp;<Link to={`/shows/${show.id}/diplomas`}>Дипломы</Link>
        , &nbsp;<a href={prepareUrl(`shows/${show.id}/reports/breeds.doc`)} >Породы.doc</a>
        , &nbsp;<a href={prepareUrl(`shows/${show.id}/reports/catalog.doc`)} >Каталог.doc</a>
        , &nbsp;<a href={prepareUrl(`shows/${show.id}/reports/show_dogs.csv`)} >Каталог.csv</a>
      </p>
      {show.closed ? <p>
        <Link to={`/shows/${show.id}/fcireport`}>заполнить отчёт FCI</Link>
        , &nbsp;<a href={prepareUrl(`shows/${show.id}/reports/fci_report.xls`)} >FCI_report.xls</a>
        , &nbsp;<Link to={`/shows/${show.id}/cruftsreport`}>заполнить отчёт CRUFTS</Link>
        , &nbsp;<a href={prepareUrl(`shows/${show.id}/reports/crufts_report.xls`)} >CRUFTS_report.xls</a>
      </p>
      : null }

    </div>
  }

  experts(show) {
    if (!show) return null;
    return (
      <div>
        <ul>
          {(show.invited_experts || []).map(expert => (
            <li key={expert.id} className="row mb-2">
              <strong className="col-xl-3 col-lg-6">{expert.name}</strong>
              <div className="col-6">
                судит 
                &nbsp;
                {expert.breeds_count ? <Link to={`/shows/${show.id}/experts/${expert.id}/sort-breeds`} title="упорядочить">{expert.breeds_count || 0} пород</Link> : ' 0 пород '}, &nbsp;
                <a href={prepareUrl(`shows/${show.id}/reports/blind_catalog.csv?eid=${expert.id}`)} >Слепой каталог</a>, &nbsp;
                <a href={prepareUrl(`shows/${show.id}/reports/expert_sheet.csv?eid=${expert.id}`)} >Ведомость</a>, &nbsp;
                <Link to={`/shows/${show.id}/experts/${expert.id}/ring-report`} >Ринговые ведомости</Link>
              </div>
            </li>)
          )}
        </ul>
      </div>
    );
  }


  contests(contests) {
    if (!contests) return null;
    return (
    <ul>
      <li className="row mb-2">
        <strong className="col-6"> Название конкурса </strong>
        <strong className="col-3"> Эксперт </strong>
        <strong className="col-3"> Ведомость </strong>
      </li>
      {(contests || []).map(contest => {
        return (
        <li key={contest.id} className="row mb-2">
          <div className="col-6">{contest.name}</div>
          <div className="col-3">{contest.expert ? <Link to={`/experts/${contest.expert.id}/edit`}>{contest.expert.name}</Link> : 'не назначен'}</div>
          <div className="col-3">{contest.expert ? <a href={prepareUrl(`/shows/${contest.show_id}/reports/contests/${contest.id}`)}>Ведомость</a> : '---'}</div>
        </li>)
      }
      )}
    </ul>
    );
  }

  setContestExperts(show, contests) {
    const experts = show.invited_experts || [];
    contests.forEach(contest => {
      if (contest.expert_id) {
        contest.expert = experts.find(exp => exp.id === contest.expert_id);
      }
      this.contestExpertsSet = true;
    });
  }

  render() {
    const {show, loading, contests, contestLoading} = this.state;
    if (show && contests && !this.contestExpertsSet) this.setContestExperts(show, contests);

    return (
      <div className="container">
        <h4>Сводная информация выставки {this.showMainInfo(show)}</h4>
        {this.renderShowInfo(show)}
        {loading && <Spinner /> }

        <h5>{show ? <Link to={`/shows/${show.id}/experts`}>Эксперты</Link> : 'Эксперты'}</h5>
        {this.experts(show)}

        <h5 className="mt-3">{show ? <Link to={`/shows/${show.id}/contests`}>Конкурсы</Link> : 'Конкурсы'}</h5>
        {contestLoading && <Spinner />}
        {this.contests(contests)}

      </div>
    );
  }

}